module.exports = __webpack_public_path__ + "img/partner-bni.37f96d5b.jpg";